package org.example.zone360.pages.widgets.matchAnalysisWidget

import org.example.zone360.components.debugPrintln

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.icons.fa.FaX
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.example.zone360.utils.getWidgetDetail
import kotlinx.browser.window
import org.example.zone360.components.ProgressIndicator
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.MatchAnalysis
import org.example.zone360.models.MatchAnalysisSubScores
import org.example.zone360.models.TrainingPriority
import org.example.zone360.models.WidgetDetailPayload
import org.example.zone360.models.WidgetDetailResponse
import org.example.zone360.theme.Palette
import org.example.zone360.theme.toSitePalette
import org.example.zone360.utils.AppGlobal
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh


@Composable
fun MatchAnalysisDetailsModal(
    widgetNo: Int,
    widgetName: String,
    widgetColor: Color,
    data: MatchAnalysis?,
    widgetKey: String,
    onClose: () -> Unit,
) {
    val sitePalette = ColorMode.current.toSitePalette()
    val breakpoint = rememberBreakpoint()

    var localData by remember { mutableStateOf<MatchAnalysis?>(null) }
    var isLoading by remember { mutableStateOf(true) }
    var errorMessage by remember { mutableStateOf<String?>(null) }

    LaunchedEffect(Unit) {
        if (data != null) {
            localData = data
            isLoading = false
            return@LaunchedEffect
        }

        isLoading = true
        errorMessage = null
        try {
            val response = getWidgetDetail(
                WidgetDetailPayload(
                    organization = AppGlobal.userData.organization,
                    seasonID = AppGlobal.selectedSeasonId,
                    widgetKey = widgetKey
                )
            )

            // ✅ Extract MatchAnalysis from the first coach
            localData = extractMatchAnalysisFromResponse(response)

        } catch (e: Exception) {
            errorMessage = e.message
            debugPrintln("Failed to fetch widget detail: ${e.message}")
            e.printStackTrace()
        } finally {
            isLoading = false
        }
    }

    val effectiveData = data ?: localData

    Box(
        modifier = Modifier
            .fillMaxSize()
            .position(Position.Fixed)
            .styleModifier {
                property("top", "0")
                property("left", "0")
            }
            .zIndex(99999)
            .backgroundColor(Color.rgba(0, 0, 0, 0.5f))
            .onClick { onClose() },
        contentAlignment = Alignment.Center
    ) {
        Box(
            modifier = Modifier
                .width(
                    when {
                        breakpoint < Breakpoint.MD -> 350.px
                        window.screen.width in 768..1024 -> 600.px
                        else -> 50.percent
                    }
                )
                .maxHeight(90.vh)
                .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                .borderRadius(16.px)
//                .overflow(Overflow.Auto)
                .scrollBehavior(ScrollBehavior.Smooth)
                .onClick { it.stopPropagation() }
                .padding(24.px)
                .styleModifier { property("position", "relative") }
        ) {
            Column(modifier = Modifier.fillMaxWidth()) {
                // Header
                Row(
                    modifier = Modifier.fillMaxWidth().margin(bottom = 24.px).flexWrap(FlexWrap.Wrap),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.SpaceBetween,
                ) {
                    Row(verticalAlignment = Alignment.CenterVertically) {
                        Box(
                            modifier = Modifier
                                .width(32.px).height(32.px)
                                .backgroundColor(Palette.CoachTalkPrimaryBlue.rgbLight)
                                .borderRadius(8.px)
                                .margin(right = 12.px),
                            contentAlignment = Alignment.Center
                        ) {
                            FieldTitleTextNormalSimple(
                                text = widgetNo.toString(),
                                fontSize = 15.px,
                                fontWeight = 700,
                                color = sitePalette.bodyBackgroundSecondary.rgb
                            )
                        }
                        FieldTitleTextNormalSimple(
                            text = widgetName,
                            fontSize = 20.px,
                            fontWeight = 700
                        )
                    }

                    Box(
                        modifier = Modifier
                            .width(32.px).height(32.px)
                            .borderRadius(50.percent)
                            .backgroundColor(Color.rgb(243, 244, 246))
                            .cursor(Cursor.Pointer)
                            .onClick { onClose() },
                        contentAlignment = Alignment.Center
                    ) {
                        FaX(
                            modifier = Modifier
                                .fontSize(14.px)
                                .color(Color.rgb(107, 114, 128))
                        )
                    }
                }

                // ── Loading State ──────────────────────────────────────────
                if (isLoading) {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(400.px),
                        contentAlignment = Alignment.Center
                    ) {
                        Column(horizontalAlignment = Alignment.CenterHorizontally) {
                            ProgressIndicator(size = 30.px)
                        }
                    }
                } else if (errorMessage != null) {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(400.px),
                        contentAlignment = Alignment.Center
                    ) {
                        Column(horizontalAlignment = Alignment.CenterHorizontally) {
                            FieldTitleTextNormalSimple(
                                text = "Failed to load data",
                                fontSize = 16.px,
                                color = Colors.Red
                            )
                            FieldTitleTextNormalSimple(
                                text = errorMessage ?: "Unknown error",
                                fontSize = 14.px,
                                color = Color.rgb(107, 114, 128)
                            )
                        }
                    }
                } else if (effectiveData == null) {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(400.px),
                        contentAlignment = Alignment.Center
                    ) {
                        FieldTitleTextNormalSimple(
                            text = "No data available",
                            fontSize = 16.px,
                            color = Color.rgb(107, 114, 128)
                        )
                    }
                } else {
                    // Score Summary Section
                    Column(modifier = Modifier.fillMaxWidth()
                        .height(600.px)
                        .padding(leftRight = 20.px)
                        .overflow(Overflow.Auto)) {
                        Row(
                            modifier = Modifier
                                .fillMaxWidth()
                                .flexWrap(FlexWrap.Wrap)
                                .margin(bottom = 24.px)
                                .padding(16.px)
                                .backgroundColor(Color.rgb(248, 250, 252))
                                .borderRadius(12.px),
                            verticalAlignment = Alignment.CenterVertically
                        )
                        {
                            Column(
                                modifier = Modifier
                                    .fillMaxWidth(90.percent)
                                    .flexWrap(FlexWrap.Wrap)
                                    .padding(
                                        left = 24.px,
                                        top = if (breakpoint < Breakpoint.MD) 20.px else 0.px
                                    )
                            ) {
                                MetricRowDetail(
                                    label = "In Possession",
                                    value = effectiveData.subScores.inPossession.toInt(),
                                    color = Color.rgb(34, 197, 94)
                                )
                                MetricRowDetail(
                                    label = "Out of Possession",
                                    value = effectiveData.subScores.outOfPossession.toInt(),
                                    color = Color.rgb(239, 68, 68)
                                )
                                MetricRowDetail(
                                    label = "Transitions",
                                    value = effectiveData.subScores.transitions.toInt(),
                                    color = Color.rgb(37, 99, 235)
                                )
                            }
                        }

                        // Three Columns: Strengths, Weaknesses, Root Causes
                        Row(
                            modifier = Modifier.fillMaxWidth().flexWrap(FlexWrap.Wrap).gap(20.px),
                            horizontalArrangement = Arrangement.spacedBy(16.px)
                        )
                        {
                            AnalysisColumn(
                                title = "STRENGTHS",
                                titleColor = Color.rgb(34, 197, 94),
                                bulletColor = Color.rgb(34, 197, 94),
                                items = effectiveData.strengths,
                                icon = "✓"
                            )

                            AnalysisColumn(
                                title = "WEAKNESSES",
                                titleColor = Color.rgb(239, 68, 68),
                                bulletColor = Color.rgb(239, 68, 68),
                                items = effectiveData.weaknesses,
                                icon = "✓"
                            )

                            AnalysisColumn(
                                title = "ROOT CAUSES",
                                titleColor = Color.rgb(245, 158, 11),
                                bulletColor = Color.rgb(245, 158, 11),
                                items = effectiveData.rootCauses,
                                icon = "•"
                            )
                        }

                        // Training Priorities Section
                        if (effectiveData.trainingPriorities.isNotEmpty()) {
                            Column(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .margin(topBottom = 24.px)
                                    .padding(16.px)
                                    .backgroundColor(Color.rgb(248, 250, 252))
                                    .borderRadius(12.px)
                            ) {
                                FieldTitleTextNormalSimple(
                                    text = "TRAINING PRIORITIES",
                                    fontSize = 15.px,
                                    fontWeight = 700,
                                    color = Color.rgb(31, 41, 55),
                                    marginBottom = 16.px
                                )

                                effectiveData.trainingPriorities.sortedByDescending { it.percentage }
                                    .forEach { priority ->
                                        Row(
                                            modifier = Modifier
                                                .fillMaxWidth()
                                                .margin(bottom = 12.px),
                                            verticalAlignment = Alignment.CenterVertically
                                        ) {
                                            FieldTitleTextNormalSimple(
                                                text = priority.area,
                                                width = if (window.screen.width < 768) 150.px else 220.px,
                                                fontSize = 14.px,
                                                fontWeight = 500,
                                                color = Color.rgb(31, 41, 55)
                                            )

                                            Box(
                                                modifier = Modifier
                                                    .weight(1f)
                                                    .height(10.px)
                                                    .backgroundColor(Color.rgb(229, 231, 235))
                                                    .borderRadius(100.px)
                                            ) {
                                                Box(
                                                    modifier = Modifier
                                                        .fillMaxHeight()
                                                        .fillMaxWidth(priority.percentage.toFloat().percent)
                                                        .backgroundColor(getPriorityColor(priority.percentage))
                                                        .borderRadius(100.px)
                                                )
                                            }

                                            FieldTitleTextNormalSimple(
                                                text = "${priority.percentage}%",
                                                fontSize = 14.px,
                                                fontWeight = 700,
                                                color = getPriorityColor(priority.percentage),
                                                marginLeft = 12.px,
                                                width = 45.px
                                            )
                                        }
                                    }
                            }
                        }
                    }
                }
            }
        }
    }
}

// ✅ Extract MatchAnalysis from the first coach in the response
private fun extractMatchAnalysisFromResponse(response: WidgetDetailResponse?): MatchAnalysis? {
    if (response == null || response.coaches.isEmpty()) return null

    val firstCoach = response.coaches.firstOrNull() ?: return null

    return MatchAnalysis(
        rootCauses = firstCoach.rootCauses,
        score = firstCoach.score,
        strengths = firstCoach.strengths,
        subScores = MatchAnalysisSubScores(
            inPossession = firstCoach.subScores?.inPossession ?: 0,
            outOfPossession = firstCoach.subScores?.outOfPossession ?: 0,
            transitions = firstCoach.subScores?.transitions ?: 0
        ),
        trainingPriorities = firstCoach.trainingPriorities.map { priority ->
            TrainingPriority(
                area = priority.area,
                percentage = priority.percentage
            )
        },
        weaknesses = firstCoach.weaknesses
    )
}

@Composable
private fun MetricRowDetail(
    label: String,
    value: Int,
    color: Color,
    breakpoint: Breakpoint = rememberBreakpoint()
) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .margin(bottom = 8.px),
        verticalAlignment = Alignment.CenterVertically
    ) {
        FieldTitleTextNormalSimple(
            text = label,
            width = if (breakpoint < Breakpoint.MD) 130.px else 150.px,
            fontSize = 14.px,
            color = Color.rgb(55, 65, 81)
        )
        Box(
            modifier = Modifier
                .weight(1f)
                .height(8.px)
                .backgroundColor(Color.rgb(229, 231, 235))
                .borderRadius(100.px)
        ) {
            Box(
                modifier = Modifier
                    .fillMaxHeight()
                    .fillMaxWidth(value.toFloat().percent)
                    .backgroundColor(color)
                    .borderRadius(100.px)
            )
        }
        FieldTitleTextNormalSimple(
            text = value.toString(),
            fontSize = 15.px,
            fontWeight = 700,
            color = color,
            marginLeft = 12.px,
            width = 30.px
        )
    }
}

@Composable
private fun AnalysisColumn(
    title: String,
    titleColor: Color,
    bulletColor: Color,
    items: List<String>,
    icon: String
) {
    Column(
        modifier = Modifier
            .flexGrow(1)
            .backgroundColor(Palette.ViewDetailBackground.rgbLight)
            .borderRadius(12.px)
            .padding(16.px)
            .then(
                if (window.screen.width < 768) {
                    Modifier
                } else {
                    Modifier.minHeight(175.px)
                }
            )
    ) {
        FieldTitleTextNormalSimple(
            text = title,
            color = titleColor,
            fontWeight = 700,
            fontSize = 15.px,
            marginBottom = 12.px
        )

        if (items.isEmpty()) {
            FieldTitleTextNormalSimple(
                text = "No data available",
                fontSize = 13.px,
                color = Color.rgb(107, 114, 128)
            )
        } else {
            items.take(3).forEachIndexed { index, item ->
                Row(
                    modifier = Modifier.margin(bottom = 6.px),
                    verticalAlignment = Alignment.Top
                ) {
                    Box(
                        modifier = Modifier
                            .width(18.px)
                            .height(18.px)
                            .backgroundColor(bulletColor)
                            .borderRadius(50.percent)
                            .flexShrink(0)
                            .margin(top = 2.px),
                        contentAlignment = Alignment.Center
                    ) {
                        FieldTitleTextNormalSimple(
                            text = icon,
                            color = Colors.White,
                            fontSize = 10.px,
                            fontWeight = 700
                        )
                    }
                    FieldTitleTextNormalSimple(
                        text = "${index + 1}. $item",
                        marginLeft = 10.px,
                        fontSize = 14.px,
                        color = Color.rgb(31, 41, 55)
                    )
                }
            }
        }
    }
}


private fun getPriorityColor(percentage: Long): Color {
    return when {
        percentage >= 30 -> Color.rgb(99, 102, 241)
        percentage >= 20 -> Color.rgb(59, 130, 246)
        percentage >= 10 -> Color.rgb(139, 92, 246)
        else -> Color.rgb(167, 139, 250)
    }
}

